/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * For complex icons that stack and/or rotate/scale etc..
 */
export interface OptionComplexIcon {

  /**
   * The base icon
   */
  icon?: string | null;

  /**
   * Offset from left
   */
  offsetLeft?: number | null;

  /**
   * Offset from top
   */
  offsetTop?: number | null;

  /**
   * Ratio
   */
  ratio?: number | null;

  /**
   * Roate degreess
   */
  rotate?: number | null;

  /**
   * Scale
   */
  scale?: number | null;

  /**
   * Style
   */
  style?: string | null;

  /**
   * Tag colour index
   */
  tagColor?: number | null;

  /**
   * Text colour
   */
  textColor?: string | null;
}

export class OptionComplexIcon {
  icon?: string | null;
  offsetLeft?: number | null;
  offsetTop?: number | null;
  ratio?: number | null;
  rotate?: number | null;
  scale?: number | null;
  style?: string | null;
  tagColor?: number | null;
  textColor?: string | null;

  constructor(value: OptionComplexIcon) {
    this.icon = value?.icon;
    this.offsetLeft = value?.offsetLeft;
    this.offsetTop = value?.offsetTop;
    this.ratio = value?.ratio;
    this.rotate = value?.rotate;
    this.scale = value?.scale;
    this.style = value?.style;
    this.tagColor = value?.tagColor;
    this.textColor = value?.textColor;
  }
}
